import {ScorecardRow} from "./row";
import {PuttsRow} from "../model/participant-card-model";
import {arrayOrEmpty} from "../../../common/extensions/array";


export function getPuttsRow(row: PuttsRow): ScorecardRow {
    return {
        name: "Putts",
        outValues: row.data.outValues,
        outTotal: row.data.outTotal,
        inValues: arrayOrEmpty(row.data.inValues),
        inTotal: row.data.inTotal,
        total: row.data.total,
        classes: "putts"
    };
}
